module.exports = __webpack_public_path__ + "img/logobetting.78052bb7.png";